

import React, { useState, useEffect, isValidElement } from 'react';
import myData from "../../data.json"
import './home.scss';
import FeatureCard from '../../components/FeatureCard';
import OutlineCard from '../../components/OutlineCard';
import JoinCard from '../../components/JoinCard';
import QuestionCard from '../../components/QuestionCard';
import CallToAction from '../../components/CallToAction';
import WorksCard from '../../components/WorksCard';
import Footer from '../../components/Footer';

function Home() {

    const [toolHover, setToolHover] = useState(false)
    const [toolDesc, setToolDesc] = useState("")
    const [toolName, setToolName] = useState("")
    const [toolHot, setToolHot] = useState("")



    function toolOnHover(element) {
        let { name, desc, hot } = element.currentTarget.dataset;

        setToolHover(true)
        setToolDesc(desc)
        setToolName(name)
        setToolHot(hot)
    }

    function toolOnLeave(e) {
        setToolHover(false)
    }


    return (
        <div className="page-home">
            <div className="banner" id="banner">
                <div className="video-cover"></div>
                <div className="img-cover"></div>
                <video src="https://ycp.limiabc.com/motion/background_1_1.mp4"  loop muted="" autoPlay="autoplay" muted name="media" preload=""></video>

                <div className="content">
                    <div className="title">全栈动效设计训练营</div>
                    <div className="sub-title">动效设计落地课程</div>
                    <div className="text">全新内容，期期迭代，动效设计视觉表现＋实践产出与落地规范 综合学习课程</div>
                    <div className="time">开课时间：2020年10月20日 价格：<font className="price">1998</font> <span> 原价2300</span> 2020年最后一班车</div>
                    <div className="toolbar">
                        <ul className="tool-icon">

                            {
                                myData.softs.map((item, index) => {

                                    return <li
                                        key={index}
                                        onMouseEnter={toolOnHover}
                                        onMouseLeave={toolOnLeave}

                                        data-name={item.name}
                                        data-desc={item.desc}
                                        data-hot={item.stars}
                                    >
                                        <img src={item.icon} alt="" />
                                    </li>
                                })

                            }


                        </ul>
                        <div className={"soft-text " + (toolHover ? "soft-text-amit" : "")} >
                            <p className="soft-title">{toolName}</p>
                            <p>{toolDesc}</p>
                            <span className="tool-hot">推荐指数：{toolHot}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="featurebox" id="featurebox">
                <div className="work-title">为何而学？</div>
                <div className="features-box-card">
                    {
                        myData.features.map((item, index) => {

                            return <FeatureCard key={index}  data={item}/>
                        })

                    }
                </div>
            </div>
            <CallToAction />
            <div className="work-outline" id="work-outline">
                <div className="outline-title">
                    课程大纲
                </div>
                <div className="outline-card-box">
                    <div className="outline-card-title">
                        <div>课程编号</div>
                        <div>课程名称</div>
                        <div className="content-title">主要内容</div>
                    </div>
                    {
                        myData.outline.map((item, index) => {

                            return <OutlineCard key={index}  data={item}/>
                        })

                    }
                </div>
            </div>

            <div className="worksbox-title" id="worksbox-title">学员作品</div>
            <div className="sub-worksbox-title">我们要教你的 不只是动效</div>
            <div className="works-desc">从软件基础，到系统的作品产出，你将对动效的视觉表现到实现原理进行全面的认识</div>
            <WorksCard />

            <div className="join-box">              
                    <JoinCard />
            </div>
            <div className="work-title" id="work-title">常见问题🤔</div>
            <div className="question-box">
                {
                    myData.question.map((item, index) => {

                        return <QuestionCard key={index}  data={item}/>
                    })

                }
                <CallToAction />
            </div>
        </div>
    );
}

export default Home;